// Configuração da API - Central do Assinante
// Endpoints corrigidos baseados na documentação do backend Delphi

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/centraldoassinante/api'  // Via proxy nginx
  : 'http://10.0.201.35:9000/api'; // Direto para desenvolvimento

// Configuração da API
const apiConfig = {
  baseURL: API_BASE_URL,
  
  // Endpoints de saúde
  health: '/health',
  
  // Endpoints de usuários
  users: {
    getUser: (cpf) => `/users/${cpf}`,
    updateUser: (cpf) => `/users/${cpf}`,
    cadastro: '/cadastro'
  },
  
  // Endpoints de boletos (CORRIGIDOS)
  boletos: {
    // ✅ CORRETO: Busca boletos pelo ID do cliente
    getBoletosByClienteId: (clienteId) => `/boletos/cliente/${clienteId}`,
    
    // ✅ CORRETO: Busca boletos pelo CPF (POST)
    buscaBoletosByCPF: '/boletos/buscaboletocliente',
    
    // ❌ INCORRETO: Retorna erro de numeric overflow
    getBoletoById: (boletoId) => `/boletos/${boletoId}`,
    
    // ✅ CORRETO: Pagamento de boleto
    payBoleto: (boletoId) => `/boletos/${boletoId}/pay`
  },
  
  // Endpoints de notificações (CORRIGIDOS)
  notifications: {
    // ✅ CORRETO: Busca todas as notificações
    getAll: '/notifications',
    
    // ✅ CORRETO: Marca notificação como lida
    markAsRead: (notificationId) => `/notifications/${notificationId}/read`
  },
  
  // Endpoints de documentos (CORRIGIDOS)
  documents: {
    // ✅ CORRETO: Busca todos os documentos
    getAll: '/documents'
  },

  // Chamados (Atendido) - backend deve retornar DISTINCT nome+bairro e chamados por cliente
  chamados: {
    // Lista de clientes distintos (nome + bairro) que já abriram chamado
    getClientesAtendido: '/chamados/atendido/clientes',
    // Chamados de um cliente, ordenados por data de abertura crescente
    getChamadosByCliente: (clienteId) => `/chamados/cliente/${clienteId}`
  }
};

// Funções auxiliares para a API
const apiHelpers = {
  // Busca ID do cliente pelo CPF
  getClienteIdByCPF: async (cpf) => {
    try {
      const response = await fetch(`${apiConfig.baseURL}/users/${cpf}`);
      const userData = await response.json();
      return userData.id; // Retorna o ID do cliente
    } catch (error) {
      console.error('Erro ao buscar ID do cliente:', error);
      throw error;
    }
  },
  
  // Busca boletos pelo CPF (usando o fluxo correto)
  getBoletosByCPF: async (cpf) => {
    try {
      // 1. Busca o ID do cliente pelo CPF
      const clienteId = await apiHelpers.getClienteIdByCPF(cpf);
      
      // 2. Busca os boletos pelo ID do cliente
      const response = await fetch(`${apiConfig.baseURL}/boletos/cliente/${clienteId}`);
      const boletos = await response.json();
      
      return boletos;
    } catch (error) {
      console.error('Erro ao buscar boletos:', error);
      throw error;
    }
  },
  
  // Busca notificações
  getNotifications: async () => {
    try {
      const response = await fetch(`${apiConfig.baseURL}/notifications`);
      const notifications = await response.json();
      return notifications;
    } catch (error) {
      console.error('Erro ao buscar notificações:', error);
      throw error;
    }
  },
  
  // Busca documentos
  getDocuments: async () => {
    try {
      const response = await fetch(`${apiConfig.baseURL}/documents`);
      const documents = await response.json();
      return documents;
    } catch (error) {
      console.error('Erro ao buscar documentos:', error);
      throw error;
    }
  }
};

// API principal com todos os métodos
const api = {
  // Configuração
  config: apiConfig,
  
  // Métodos de saúde
  health: async () => {
    const response = await fetch(`${apiConfig.baseURL}/health`);
    return response.json();
  },
  
  // Métodos de usuários
  getUser: async (cpf) => {
    const response = await fetch(`${apiConfig.baseURL}/users/${cpf}`);
    return response.json();
  },
  
  updateUser: async (cpf, data) => {
    const response = await fetch(`${apiConfig.baseURL}/users/${cpf}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });
    return response.json();
  },
  
  cadastro: async (data) => {
    const response = await fetch(`${apiConfig.baseURL}/cadastro`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });
    return response.json();
  },
  
  // Métodos de boletos (CORRIGIDOS)
  getBoletos: async (clienteId) => {
    const response = await fetch(`${apiConfig.baseURL}/boletos/cliente/${clienteId}`);
    return response.json();
  },
  
  getBoletoById: async (boletoId) => {
    const response = await fetch(`${apiConfig.baseURL}/boletos/${boletoId}`);
    return response.json();
  },
  
  payBoleto: async (boletoId, data) => {
    const response = await fetch(`${apiConfig.baseURL}/boletos/${boletoId}/pay`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });
    return response.json();
  },
  
  // Métodos de notificações (CORRIGIDOS)
  getNotifications: async () => {
    const response = await fetch(`${apiConfig.baseURL}/notifications`);
    return response.json();
  },
  
  markNotificationAsRead: async (notificationId) => {
    const response = await fetch(`${apiConfig.baseURL}/notifications/${notificationId}/read`, {
      method: 'PUT'
    });
    return response.json();
  },
  
  // Métodos de documentos (CORRIGIDOS)
  getDocuments: async () => {
    const response = await fetch(`${apiConfig.baseURL}/documents`);
    return response.json();
  },

  // Chamados (Atendido)
  getClientesAtendido: async () => {
    const response = await fetch(`${apiConfig.baseURL}${apiConfig.chamados.getClientesAtendido}`);
    if (!response.ok) throw new Error('Erro ao carregar clientes');
    return response.json();
  },

  getChamadosByCliente: async (clienteId) => {
    const response = await fetch(`${apiConfig.baseURL}${apiConfig.chamados.getChamadosByCliente(clienteId)}`);
    if (!response.ok) throw new Error('Erro ao carregar chamados do cliente');
    return response.json();
  },
  
  // Helpers
  helpers: apiHelpers
};

export default api;
